var _rect, _ellipse, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTransmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 140,
    viewBox: "0 0 174 140",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.1816,
    y: 0.735077,
    width: 81.0283,
    height: 138.704,
    rx: 8.5,
    fill: "black",
    fillOpacity: 0.22,
    stroke: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 17.4456,
    ry: 17.7732,
    transform: "matrix(0.999896 -0.0144323 -0.0452731 0.998975 139.336 38.6306)",
    fill: "#FC7292"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.347 47.5281C142.51 39.7836 138.106 35.2276 127.359 40.2943",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 104,
    width: 75.1985,
    height: 14.3858,
    rx: 2,
    fill: "#EAEAEA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2695,
    y: 105.962,
    width: 11.7702,
    height: 10.4624,
    rx: 2,
    fill: "#FC7292"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.001,
    y: 109.885,
    width: 26.156,
    height: 1.3078,
    rx: 0.6539,
    fill: "#807376"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.001,
    y: 111.847,
    width: 39.234,
    height: 1.3078,
    rx: 0.6539,
    fill: "#1E273B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 80,
    width: 62.1205,
    height: 14.3858,
    rx: 2,
    fill: "#EAEAEA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.26953,
    y: 81.9617,
    width: 11.7702,
    height: 10.4624,
    rx: 2,
    fill: "#FC7292"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.002,
    y: 85.8851,
    width: 26.156,
    height: 1.3078,
    rx: 0.6539,
    fill: "#807376"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 17.002,
    y: 87.8468,
    width: 39.234,
    height: 1.3078,
    rx: 0.6539,
    fill: "#1E273B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransmission);
export default __webpack_public_path__ + "static/media/no-transmission.ed05ad47af2ba731e7c527d08881194d.svg";
export { ForwardRef as ReactComponent };